<script setup>
import { computed } from 'vue';
import SidenavList from './SidenavList.vue';
import { useMainStore } from '../../stores/index';

const Store = useMainStore();
Store.Token();

const isCollapsed = computed(() => {
  if (Store.mobile) return false;
  return !Store.isPinned;
});

const sidenavClasses = computed(() => {
  return {
    'side-nav-person': !Store.mobile && !isCollapsed.value,
    'side-nav-person-pined': !Store.mobile && isCollapsed.value,
    'side-nav-person-pined-mobile': Store.mobile
  };
});
</script>

<template>
  <aside
    v-if="Store.mobile && Store.isPinned"
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 sidenav-color sidebar-fixed sidebar-mobile"
  >
    <SidenavList />
  </aside>

  <aside
    v-if="!Store.mobile"
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 sidenav-color sidebar-fixed"
    :class="sidenavClasses"
  >
    <SidenavList />
  </aside>
</template>